import React from 'react';
import PropTypes from 'prop-types';
import './newRadioButton.scss';
import { requiredradio } from '../../utils/validation';
import { Field } from 'redux-form';

const RadioField = ({ id, field, fieldId, v, index, checked }) => {
  const getClassname = (toggle) => {
    return toggle
      ? 'newRadio-container_radioGroup_style_active'
      : 'newRadio-container_radioGroup_style_notActive';
  };
  return (
    <label id={id} htmlFor={fieldId} className={getClassname(checked)}>
      <Field
        key={field.name}
        validate={field.validations.required ? [requiredradio] : null}
        name={field.name}
        component="input"
        type={field.type}
        className={field.type}
        parse={(val) => val === 'true'}
        disabled={field.disabled}
        value={v.value}
        id={fieldId}
      />
      <div className="radio-circle">
        <div className="radio-circle-inner" />
      </div>
      <label id={v.label} key={index} className="inline-block-span" htmlFor={fieldId}>
        {v.label}
      </label>
    </label>
  );
};

RadioField.propTypes = {
  id: PropTypes.string,
  field: PropTypes.object,
  fieldId: PropTypes.string,
  v: PropTypes.object,
  index: PropTypes.number,
  checked: PropTypes.bool
};

export default RadioField;
